import React, { useState, useRef } from "react";
import { DirectUpload } from '@rails/activestorage';

export default function UploadButton({handleChange}) {
  const [fileUploading, setFileUploading] = useState(false);
  const inputFiles = useRef(null);

  const onFilesChange = (files) => {
    Array.from(files).forEach(file => uploadFile(file))
  }

  const uploadFile = (file) => {
    if (file.name.endsWith('.jfif')) {
      Alert.show('error', '.jiff image is not allowed');
      return;
    }

    setFileUploading(true)
    const upload = new DirectUpload(file, '/api/v1/direct_uploads');
    upload.create((error, blob) => {
      if (error) {
        // Handle the error
        Alert.show("error", "Could not update. Try again.");
      } else {
        setFileUploading(false);
        handleChange(blob);
      }
    })
  }
  
  // TODO: only handling for 1 image (no other formats supported yet) 

  return (    
    <div className="d-flex">
      <input ref={inputFiles} id="uploader" type="file" accept="image/*"
        onChange={e => {
          return onFilesChange(e.currentTarget.files)}}
        direct_upload="true"
        className="d-none"
      />

      <button onClick={() => inputFiles.current.click()} name="button" className="btn btn-primary mx-auto">
        {fileUploading && (<span><i className="fa fa-spinner-third fa-spin mr-2"></i> Uploading...</span>)}
        {!fileUploading && (<span><i className="fa fa-plus mr-2"></i> Update Image</span>)}
      </button>
    </div>
  );
}
